import { getFingerprintData } from '@/utils/finger-print';

import apiClient from './api-client';

export const getLoginUrl = async (
  tenantId: number,
  email?: string
): Promise<{ url: string }> => {
  const fingerprintData = await getFingerprintData();

  const hostUrl = globalThis.location.origin;

  const res = await apiClient.post(
    `/auth/login-url?tenant=${tenantId}&returnUrl=${hostUrl}`,
    {
      fingerprint: fingerprintData,
      email: email || null,
    },
    {
      // @ts-expect-error - custom flag to prevent retry in interceptor
      skipAuthRetry: true,
    }
  );

  return { url: res.data.url };
};

export const getTenantInfo = async (domain: string) => {
  const res = await apiClient.get(`/auth/tenant-info?domain=${domain}`, {
    // @ts-expect-error - custom flag to prevent retry in interceptor
    skipAuthRetry: true,
  });
  return res.data;
};

export const getProfile = async () => {
  const res = await apiClient.get(`/AdminManagement/admin/profile`);
  return res.data;
};

export const logout = async (): Promise<void> => {
  // Check if any sv_xid cookie exists (root or tenant-specific) before calling API
  const cookieStr = document.cookie;
  const hasSvXid = cookieStr.includes('sv_xid');

  if (!hasSvXid) {
    // eslint-disable-next-line no-console
    console.log(
      '[Auth Service] Missing sv_xid cookie, skipping /auth/logout API call.'
    );
    return;
  }

  await apiClient.post(
    '/auth/logout',
    {},
    {
      // @ts-expect-error - custom flag to prevent retry in interceptor
      skipAuthRetry: true,
    }
  );
};

export const refreshToken = async (): Promise<void> => {
  await apiClient.post(
    '/auth/refresh',
    {},
    {
      // @ts-expect-error - custom flag to prevent retry in interceptor
      skipAuthRetry: true,
    }
  );
};

export const finalizeLogin = async (sessionKey: string, tenantId: number) => {
  const res = await apiClient.post(
    '/auth/finalize-login',
    {
      sessionKey,
      tenantId,
    },
    {
      // @ts-expect-error - custom flag to prevent retry in interceptor
      skipAuthRetry: true,
    }
  );
  return res.data;
};

export const completeLogin = async (
  code: string
): Promise<{ csrfToken: string; expiresAt: string }> => {
  const res = await apiClient.get(`/auth/complete-login?code=${code}`, {
    // @ts-expect-error - custom flag to prevent retry in interceptor
    skipAuthRetry: true,
  });
  return res.data;
};
